$(window).on('load', () => {
  const $contactCards = $('[data-hei-contact-details]');
  $contactCards.each(function () {
    const $this = $(this);
    $.ajax({
      url: $this.data('hei-contact-details'),
      method: 'GET',
      success: (resp) => {
        setTimeout(() => {
          $this.closest('.cms-vcard').replaceWith(resp);
        }, 300);
      },
      error: (resp) => {
        console.error(resp);
      },
    });
  });
});
